var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer-container"},[_c('div',[_vm._v("主办单位：集友科技创新（深圳）有限公司")]),_c('div',[_vm._v("地址：深圳市福田区梅林街道梅都社区中康路136号深圳新一代产业园5栋1101-1206")]),_c('div',[_vm._v("ICP主体备案号"),_c('a',{attrs:{"target":"_blank","href":"https://beian.miit.gov.cn"}},[_vm._v("粤ICP备2023001811号")])])])
}]

export { render, staticRenderFns }